import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
    faRedoAlt,
    faSync,
    faFastForward,
    faCogs,
    faVolumeUp,
    faInfo,
    faCaretSquareRight,
    faCaretSquareLeft,
    faLayerGroup,
    faStop,
    faSpinner,
    faFastBackward,
    faVolumeOff,
    faHistory,
    faEllipsisH,
    faWindowClose,
    faHome
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faRedoAlt,
    faSync,
    faFastForward,
    faCogs,
    faVolumeUp,
    faInfo,
    faCaretSquareRight,
    faCaretSquareLeft,
    faLayerGroup,
    faStop,
    faSpinner,
    faFastBackward,
    faVolumeOff,
    faHistory,
    faEllipsisH,
    faWindowClose,
    faHome
);

Vue.component('fa-icon', FontAwesomeIcon)